/** Budget preparation values; no VAT, lease share or posting policy is inferred. */
export const budgetChargeTypes = ['Service charge', 'Reserve contribution', 'Specific property', 'Metered separately'];
export const budgetAmountStates = ['Amount', 'Zero', 'Unknown', 'Included elsewhere', 'Deferred', 'Separately billed'];
export const budgetComparatorTypes = ['Previous budget', 'Previous actuals', 'Current forecast'];
export function budgetPennies(text) {
    if (!/^(?:0|[1-9]\d{0,10})(?:\.\d{1,2})?$/.test(text))
        throw Error('Use a non-negative amount with at most two decimal places.');
    const [whole, part = ''] = text.split('.');
    const n = Number(whole) * 100 + Number(part.padEnd(2, '0'));
    if (!Number.isSafeInteger(n))
        throw Error('Amount is too large.');
    return n;
}
export const budgetDecimal = (n) => (n / 100).toFixed(2);
/** Planned cost lines use nearest-pound, half-up rounding; actuals and property shares do not. */
export const wholeBudgetAmount = (value) => budgetDecimal(Number((BigInt(budgetPennies(value)) + 50n) / 100n) * 100);
export function roundBudgetCost(line) {
    const gross = wholeBudgetAmount(line.gross), net = line.net === null ? null : wholeBudgetAmount(line.net);
    const vat = line.vat === null ? null : net === null ? wholeBudgetAmount(line.vat) : budgetDecimal(budgetPennies(gross) - budgetPennies(net));
    return { ...line, gross, net, vat, roundingSource: { gross: line.gross, net: line.net, vat: line.vat } };
}
function day(value) { if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
    throw Error('Use a complete date.'); const n = Date.parse(value + 'T00:00:00Z'); if (!Number.isFinite(n) || new Date(n).toISOString().slice(0, 10) !== value)
    throw Error('Use a valid date.'); return n / 86400000; }
export function budgetPeriod(startsOn, endsOn) { if (day(endsOn) < day(startsOn))
    throw Error('The budget end must be on or after its start.'); return { startsOn, endsOn }; }
export function calculatedBudgetAmount(calculation, period) {
    const first = day(calculation.startsOn), last = day(calculation.endsOn);
    budgetPeriod(period.startsOn, period.endsOn);
    if (last < first)
        throw Error('Coverage must end on or after it starts.');
    const amount = budgetPennies(calculation.amount);
    if (calculation.basis === 'One-off')
        return budgetDecimal(amount);
    const days = Math.max(0, Math.min(last, day(period.endsOn)) - Math.max(first, day(period.startsOn)) + 1);
    return budgetDecimal(Number((BigInt(amount) * BigInt(days) * 2n + BigInt(last - first + 1)) / (2n * BigInt(last - first + 1))));
}
export function budgetTreatmentTotal(lines, type) { return budgetDecimal(lines.filter(l => (l.chargeType ?? 'Service charge') === type).reduce((n, l) => n + budgetPennies(l.gross), 0)); }
export function budgetLineProblem(line) {
    const gross = budgetPennies(line.gross), state = line.amountState ?? 'Amount';
    if (state !== 'Amount' && gross !== 0)
        return `${state} must not carry a budget amount. Record its explanation separately.`;
    if (line.chargeType === 'Metered separately' && gross !== 0)
        return 'Separately metered charges are excluded from the annual budget.';
    if (line.chargeType === 'Specific property' && !line.propertyReference?.trim())
        return 'Name the properties participating in this specific charge.';
    if (line.comparatorAmount !== undefined && !line.comparatorType)
        return 'Choose whether the comparison is a previous budget, previous actuals or current forecast.';
    if (line.comparatorAmount !== undefined)
        budgetPennies(line.comparatorAmount);
    if (line.net !== null && budgetPennies(line.net) > gross || line.vat !== null && budgetPennies(line.vat) > gross)
        return 'Net or VAT cannot exceed the amount including VAT.';
    if (line.net !== null && line.vat !== null && budgetPennies(line.net) + budgetPennies(line.vat) !== gross)
        return 'Gross must equal net plus VAT.';
    return null;
}
//# sourceMappingURL=budget-workflow.js.map